module.exports = __webpack_public_path__ + "static/media/bliss.8e93fd91.jpg";